"use client";

import Link from "next/link";
import { event as gtagEvent } from "@/lib/gtag";
import { getQuestionById } from "@/lib/questions";

interface Props {
  slug: string;
  questionIds: number[];
}

export function GuideCtaSection({ slug, questionIds }: Props) {
  const handleClick = (questionId: number) => {
    gtagEvent("guide_bottom_cta_click", {
      guide_slug: slug,
      question_id: questionId,
      cta_position: "bottom",
    });
  };

  return (
    <div className="my-12 p-6 md:p-8 rounded-lg bg-primary/5 border border-primary/20">
      <h2 className="text-lg font-bold text-on-surface mb-4">
        MENRENで実際に練習してみよう
      </h2>
      <p className="text-sm text-on-surface-variant mb-5">
        この記事で紹介した質問を、AIの面接官を相手に実際に練習してみましょう。
        音声で回答するだけで、5つの軸であなたの回答力をスコアリングします。
      </p>
      <div className="flex flex-wrap gap-3">
        {questionIds.map((qId) => {
          const question = getQuestionById(qId);
          const label = question.text.replace(/。$/, "");
          return (
            <Link
              key={qId}
              href={`/practice?questionId=${qId}&utm_source=guide&utm_medium=cta&utm_content=${slug}`}
              onClick={() => handleClick(qId)}
              className="inline-flex items-center gap-1 text-sm font-semibold text-white bg-accent hover:bg-accent-hover px-5 py-2.5 rounded-md transition-colors shadow-[0_4px_12px_rgba(246,122,80,0.2)]"
            >
              「{label}」を練習する →
            </Link>
          );
        })}
      </div>
    </div>
  );
}
